import { environment } from 'src/environments/environment';

/**
 * Metodos de pago de la LIGA DE COLABORADOR (boletos-colaborador/<id> y venta-digital-externa/<id>).
 * Switch en environment.metodosPagoLigaColaborador: { mit: false } -> MIT no sale para esos boletos.
 *
 * POR QUE POR FOLIO Y NO POR FLUJO: el carrito puede mezclar boletos de la liga con boletos
 * de la maquinita, y 'BoletosCol' se pisa cada vez que el comprador entra a otra pantalla
 * (liga -> maquinita -> liga...). Lo que no cambia es el folio: cada boleto que entra al
 * carrito desde la liga queda registrado aqui, y si CUALQUIERA de los boletos que se van a
 * pagar paso por la liga, MIT se oculta. Las ligas de la App (pagar/*) no marcan nada.
 *
 * Vive en sessionStorage (por pestaña, igual que el carrito) y sobrevive a limpiarCompra().
 * true (o sin config) = comportamiento normal: manda lo que diga APIs Pagos / SGSA.
 */
export class MetodosLigaColaborador {
  private static readonly KEY = 'foliosLigaColaborador';

  /** Registra los folios que entraron al carrito desde la liga de colaborador. */
  static marcar(boletos: Array<{ folio?: any }>): void {
    const folios = new Set(MetodosLigaColaborador.leer());
    for (const b of boletos || []) {
      const folio = MetodosLigaColaborador.normalizar(b && b.folio);
      if (folio) folios.add(folio);
    }
    sessionStorage.setItem(MetodosLigaColaborador.KEY, JSON.stringify(Array.from(folios)));
  }

  /** false si el switch apaga MIT y alguno de estos folios paso por la liga. */
  static mitPermitido(folios: Array<string>): boolean {
    const config = (environment as any).metodosPagoLigaColaborador;
    if (!config || config.mit !== false) return true;
    const marcados = new Set(MetodosLigaColaborador.leer());
    return !(folios || []).some((f) => marcados.has(MetodosLigaColaborador.normalizar(f)));
  }

  /** Para sobrevivir a un sessionStorage.clear(): respaldar antes, restaurar después. */
  static respaldar(): string | null {
    return sessionStorage.getItem(MetodosLigaColaborador.KEY);
  }

  static restaurar(respaldo: string | null): void {
    if (respaldo) sessionStorage.setItem(MetodosLigaColaborador.KEY, respaldo);
  }

  private static leer(): Array<string> {
    try {
      const lista = JSON.parse(sessionStorage.getItem(MetodosLigaColaborador.KEY) || '[]');
      return Array.isArray(lista) ? lista : [];
    } catch {
      return [];
    }
  }

  private static normalizar(folio: any): string {
    return (folio ?? '').toString().trim();
  }
}
